// @owners { team: patients-team }
import { type LineItem, LineItemTypeMap } from '@alto/scriptdash/alto/pricing/patients/v3/pricing_endpoint';

/** Extract dispensing fee analytics params from order pricing line items. */
export const getDispensingFeeAnalyticsParams = (
  lineItems: LineItem[] | undefined | null,
): { has_program_dispensing_fee: boolean; total_program_dispensing_fee: number | null } => {
  const feeLineItem = lineItems?.find(
    (item) =>
      item.key === LineItemTypeMap.TOTAL_PROGRAM_DISPENSING_FEE && typeof item.value === 'number' && item.value > 0,
  );
  return {
    has_program_dispensing_fee: !!feeLineItem,
    total_program_dispensing_fee: feeLineItem?.value ?? null,
  };
};

/** True when patient pricing includes a positive program dispensing fee (order-level line item). */
export const hasProgramDispensingFee = (lineItems: LineItem[] | undefined | null): boolean => {
  if (!lineItems?.length) {
    return false;
  }
  return lineItems.some(
    (item) =>
      item.key === LineItemTypeMap.TOTAL_PROGRAM_DISPENSING_FEE && typeof item.value === 'number' && item.value > 0,
  );
};
